.hr{border:1px solid var(--gray-200);}